import { Editor } from "slate";
import { CustomEditor, FormatMark } from "../../types";

export const isMarkActive = (editor: CustomEditor, format: FormatMark) => {
  const marks = Editor.marks(editor);
  return marks ? marks[format] === true : false;
};

export const toggleMark = (editor: CustomEditor, format: FormatMark) => {
  const isActive = isMarkActive(editor, format);
  if (isActive) {
    Editor.removeMark(editor, format);
  } else {
    Editor.addMark(editor, format, true);
  }
};
